import { render, staticRenderFns } from "./VchtBanner.vue?vue&type=template&id=2398e61c&lang=pug"
import script from "./VchtBanner.vue?vue&type=script&lang=js"
export * from "./VchtBanner.vue?vue&type=script&lang=js"
import style0 from "./VchtBanner.vue?vue&type=style&index=0&id=2398e61c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports